import axios from 'axios';
axios.defaults.withCredentials = true;

import { get, post, deletes, resourceRequest, put } from './axios.js';

export { resourceRequest };

/**
 * 字典
 * **/
//批量根据常量类型查询常量值（平行结构，查多个）(用于选择)--------------------------------------------
export const getDictBatch = (data) => {
  return get(`/resource-center/dict/doBatch`, data);
};

//根据标签搜索
export const getLabelSearch = (data) => {
  return get(`/resource-center/dict/labelSearch`, data);
};

//根据类型查询树形结构的常量值(单个查，树形结构)--------------------------------------------
export const getDictTree = (data) => {
  return get(`/resource-center/dict/tree`, data);
};

//根据课程信息查询章节树--------------------------------------------
export const getChapterTree = (data) => {
  return get(`/resource-center/lesson-chapter/tree`, data);
};

//根据课程信息查询知识点列表--------------------------------------------
export const getKnowledgeTree = (data) => {
  return get(`/resource-center/knowledge/tree`, data);
};

/**
 * 资源中心
 *
 * **/
//查询资源--------------------------------------------
export const getResource = (data) => {
  return get(`/resource-center/resource`, data);
};

/**
 * 资源中心详情展示
 *
 * **/
//根据文件资源id查询文件资源--------------------------------------------
export const getIdResource = (id) => {
  return get(`/resource-center/file-resource/${id}`);
};

// 视频转码接口  begin
// 获取ossId
export const getAddressOssId= (id) => {
  return get(`/resource-center/ffmpeg/oss/address?ossId=${id}`)
}

// http://192.168.5.113:9019/resource-center/ffmpeg/query/path?path=12
export const getPath= (data) => {
  return get(`/resource-center/ffmpeg/query/path`,data)
}

// http://192.168.5.113:9019?assessHost=12&bucket=1221&callbackAddress=111&ffmpegType=14212&path=11&resourceId=11&resourceType=11&tableNameType=11
export const getPathData= (data) => {
  return get(`/resource-center/ffmpeg/getPath`,data)
}


// 视频转码接口  end


//查询用户是否已对某资源点赞--------------------------------------------
export const isLike = (resourceId) => {
  return get(`/resource-center/file-resource/${resourceId}/like/user`);
};

//用户点赞某资源--------------------------------------------
export const userLike = (resourceId) => {
  return post(`/resource-center/file-resource/${resourceId}/like/user`);
};

//查询某资源的点赞量--------------------------------------------
export const userLikeNum = (resourceId) => {
  return get(`/resource-center/file-resource/${resourceId}/likeNum`);
};

//用户取消点赞某资源--------------------------------------------
export const userDislike = (resourceId) => {
  return deletes(`/resource-center/file-resource/${resourceId}/like/user`);
};
//查询用户是否已对某资源收藏--------------------------------------------
export const isFavorite = (resourceId) => {
  return get(`/resource-center/file-resource/${resourceId}/favorite/user`);
};
//查询用户已收藏资源的id列表--------------------------------------------
export const isFavoriteList = (data) => {
  return get(`/resource-center/file-resource/favorite/resourceId`, data);
};

//用户收藏某资源--------------------------------------------
export const userFavorite = (resourceId) => {
  return post(`/resource-center/file-resource/${resourceId}/favorite/user`);
};

//用户取消收藏某资源--------------------------------------------
export const delFavorite = (resourceId) => {
  return deletes(`/resource-center/file-resource/${resourceId}/favorite/user`);
};
//查询用户是否已对某资源发表评论--------------------------------------------
export const isReviewed = (resourceId) => {
  return get(`/resource-center/file-resource/${resourceId}/isReviewed/user`);
};
//用户对资源发表评论--------------------------------------------
export const userReview = (data) => {
  return post(`/resource-center/file-resource/review/user`, data);
};
//查询某资源的评论--------------------------------------------
export const getReview = (data) => {
  return get(`/resource-center/file-resource/${data.resourceId}/review`, data);
};
//用户获取OSS文件临时访问地址(带临时凭证)--------------------------------------------
export const getPersignedUrl = (data) => {
  return get(`/resource-center/oss-file/user/persignedUrl/${data.id}`, data);
};

//根据文件id获取文件信息
export const getFileInfo = (ids) => {
  return get(`/resource-center/oss-file/admin/infoList`, ids);
};

/**
 * 题库中心
 *
 * **/
//根据条件查询内容
export const selectQuestion = (data) => {
  return get(`/resource-center/question`, data);
};
//根据题目id获取题目解析
export const getTopicParse = (id) => {
  return get(`/resource-center/question/${id}`);
};
//获取题库图片地址前缀接口
export const questionPicPrefix = () => {
  return get(`/resource-center/dict/questionPicPrefix`);
};

/**
 * 卷库中心
 *
 * **/
export const selectPaper = (data) => {
  return get(`/resource-center/paper`, data);
};

/**
 * 图书中心
 *
 * **/
//电子教材--------------------------------------------
export const getETextbook = (data) => {
  return get(`/resource-center/textbook`, data);
};

//电子图书--------------------------------------------
export const getDigitalBook = (data) => {
  return get(`/resource-center/books`, data);
};

/**
 * 应用中心
 *
 * **/
//绿色应用--------------------------------------------
export const getGreenApp = (data) => {
  return get(`/resource-center/green-app`, data);
};

/**
 * 个人中心
 * **/
export const getUserFavorite = (data) => {
  // resourceType  卷库 应用 图书 资源等
  return get(`/resource-center/${data.resourceType}/user/favorite`, data);
};

//获取OSS文件上传凭证
export const getUploadPolicies = (data) => {
  return get(`/resource-center/oss-file/admin/uploadPolicies`, data);
};

// 获取ossUpload上传凭证
export const ossUpload = (url, data, uploadCallback, index = 1) => {
  return axios({
    method: 'post',
    url: url,
    withCredentials: false,
    data: data,
    onUploadProgress: (progressEvent) => {
      uploadCallback(progressEvent, index);
    },
  });
};

//添加教材--------------------------------------------
export const addTextbook = (data) => {
  return post(`/resource-center/textbook/admin`, data);
};

//根据id修改教材
export const setTextbook = (data) => {
  return put(`/resource-center/textbook/admin`, data);
};

//根据id删除教材
export const delTextbook = (id) => {
  return deletes(`/resource-center/textbook/admin/${id}`);
};

//删除资源
export const delResource = (type, id) => {
  return deletes(`/resource-center/${type}/${id}`);
};

//根据id获取资源
export const IdGetResource = (type, id) => {
  return get(`/resource-center/${type}/${id}`);
};

//根据id修改资源
export const setResource = (type, data) => {
  return put(`/resource-center/${type}`, data);
};

//后台分页查询教材--------------------------------------------
export const getPageTextbook = (data) => {
  return get(`/resource-center/textbook/admin`, data);
};

//后台分页查询图书--------------------------------------------
export const getDigitalBookAdmin = (data) => {
  return get(`/resource-center/books/admin`, data);
};

//添加图书--------------------------------------------
export const addDigitalBook = (data) => {
  return post(`/resource-center/books`, data);
};

//后台分页查询资源--------------------------------------------
export const getResourceAdmin = (data) => {
  return get(`/resource-center/resource/admin`, data);
};

//添加资源--------------------------------------------
export const addResource = (data) => {
  return post(`/resource-center/resource`, data);
};

//后台分页查询试卷--------------------------------------------
export const getPaperAdmin = (data) => {
  return get(`/resource-center/paper/admin`, data);
};

//添加试卷--------------------------------------------
export const addPaper = (data) => {
  return post(`/resource-center/paper`, data);
};

/**
 * 教材 delete
 *
 * **/
//获取教材列表--------------------------------------------
export const selectTextBook = (data) => {
  return get(`/resource-center/textbook/common`, data);
};

//根据id获取教材详情
export const getTextBook = (id) => {
  return get(`/resource-center/textbook/${id}`);
};

/**
 * 同步资源  delete
 *
 * **/

//根据条件查询内容
export const selectSyncResource = (data) => {
  return get(`/resource-center/sync-resource/common`, data);
};

//根据id查询同步资源
export const getSyncResource = (id) => {
  return get(`/resource-center/sync-resource/${id}`);
};
